import { cn } from '@/lib/utils'
import { memo, useEffect, useState } from 'react'

/** `public/assets/Pelgo-Hero 2.mp4` */
export const PELGO_HERO_VIDEO_SRC = '/assets/Pelgo-Hero%202.mp4'

type PelgoHeroBackgroundVideoProps = {
  className?: string
}

export const PelgoHeroBackgroundVideo = memo(function PelgoHeroBackgroundVideo({
  className,
}: PelgoHeroBackgroundVideoProps) {
  const [failed, setFailed] = useState(false)
  const [shouldLoad, setShouldLoad] = useState(false)

  useEffect(() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    const connection = (navigator as Navigator & { connection?: { saveData?: boolean } }).connection
    if (prefersReducedMotion || connection?.saveData) return

    let timeoutId: number | undefined
    let idleId: number | undefined
    const requestIdle = (
      window as unknown as {
        requestIdleCallback?: (
          callback: IdleRequestCallback,
          options?: IdleRequestOptions,
        ) => number
      }
    ).requestIdleCallback
    if (requestIdle) {
      idleId = requestIdle.call(window, () => setShouldLoad(true), { timeout: 2000 })
    } else {
      timeoutId = window.setTimeout(() => setShouldLoad(true), 1200)
    }

    return () => {
      if (idleId !== undefined) window.cancelIdleCallback?.(idleId)
      if (timeoutId !== undefined) window.clearTimeout(timeoutId)
    }
  }, [])

  if (failed || !shouldLoad) return null

  return (
    <video
      autoPlay
      muted
      loop
      playsInline
      preload="metadata"
      aria-hidden
      className={cn(
        'decorative-bg-video absolute inset-0 -z-10 h-full w-full object-cover',
        className,
      )}
      onError={() => setFailed(true)}
    >
      <source src={PELGO_HERO_VIDEO_SRC} type="video/mp4" />
    </video>
  )
})
